/**
 * 把 antd App 上下文里的 message / notification 实例注册到全局，
 * 供 axios 拦截器等非组件代码使用（避免 antd 5 静态方法的上下文告警）。
 */

import { useEffect } from 'react';
import { App } from 'antd';
import { registerFeedback } from '@/utils/feedback';

export function FeedbackBridge(): null {
  const { message, notification } = App.useApp();

  useEffect(() => {
    registerFeedback({ message, notification });
  }, [message, notification]);

  return null;
}
